export default function isPhoneNumber(str) {
  const alphanumeric = str.replace(/[^0-9a-zA-Z]/g, '')
  return alphanumeric.length > 0 && alphanumeric.replace(/[^0-9]/g) == alphanumeric
}
